export default __webpack_public_path__ + "static/media/pay respects 9.69fd4911.png";